export default __webpack_public_path__ + "static/media/bell-active.d1d77620.svg";